import React from "react";
import i18n from "../lib/i18n";
import SuggestionListContainer from "./SuggestionListContainer";
import Modal from "./Modal";

const ActionSuggestionModal = (props) => {
  return (
    <Modal
      includeDialog={false}
      title={i18n.t("js.components.action_suggestion_modal.suggestion")}
      onClose={props.onClose}
    >
      <SuggestionListContainer
        onSelect={props.onSelect}
        initialFilter={props.initialFilter}
        hasMaskedSuggestions={props.hasMaskedSuggestions}
        sustainabilityEnabled={props.sustainabilityEnabled}
      />
    </Modal>
  );
};

export default ActionSuggestionModal;
